'use strict';

var _ = require('lodash');
var MarketAnalysisToggleController = function MarketAnalysisToggleController($scope) {
  $scope.MODE_MARKET = 'market';
  $scope.MODE_MARKET_PRODUCT_GROUP = 'market-product-group';
  $scope.MODE_SERVICE = 'service';
  $scope.toggleModes = {};
  $scope.toggleModes[$scope.MODE_MARKET] = {
    label: 'Market',
    value: $scope.MODE_MARKET,
    selected: false,
    disabled: true
  };
  $scope.toggleModes[$scope.MODE_MARKET_PRODUCT_GROUP] = {
    label: 'Market Product',
    value: $scope.MODE_MARKET_PRODUCT_GROUP,
    selected: false,
    disabled: true
  };
  $scope.toggleModes[$scope.MODE_SERVICE] = {
    label: 'Service',
    value: $scope.MODE_SERVICE,
    selected: false,
    disabled: true
  };
  $scope.toggleMode = function (currentMode) {
    _.forEach($scope.toggleModes, function (mode) {
      mode.selected = false;
    });
    if (currentMode === 'market-product-group') {
      $scope.toggleModes[$scope.MODE_MARKET].disabled = false;
    }
    if (currentMode === 'service') {
      $scope.toggleModes[$scope.MODE_MARKET].disabled = false;
    }
    $scope.toggleModes[currentMode].selected = true;
    $scope.toggleModes[currentMode].disabled = false;
    $scope.toggleMarketAnalysisMode(currentMode);
  };
  function disableMode(mode, value) {
    $scope.toggleModes[mode].disabled = value;
  }
  $scope.onFilterApplied = function (event, isOneMarketSelected) {
    disableMode($scope.MODE_SERVICE, !isOneMarketSelected);
    disableMode($scope.MODE_MARKET_PRODUCT_GROUP, false);
  };
};
MarketAnalysisToggleController.$inject = ['$scope'];
module.exports = MarketAnalysisToggleController;